<kendo-dialog
	title="{{ progress.auditName }}"
	*ngIf="dialogOpened"
	(close)="close('dialog')"
	[minWidth]="250"
	class="kpa-audit-dialog-container">
	<div
		id="auditQuestions"
		*ngFor="let question of questionCollection.questions; let i = index">
		<kpa-loader></kpa-loader>
		<kpa-question-view
			id="question_{{ i }}"
			[questionData]="question"></kpa-question-view>

		<kpa-file-upload
			id="uploader_{{ i }}"
			[questionAttachments]="question.answerAttachments"
			[questionId]="question.questionId"
			(fileAdded)="onFileAdded($event)"
			(fileRemoved)="onFileRemoved($event)"></kpa-file-upload>
	</div>
	<kpa-pagination
		id="paginator"
		[minimumQuestions]="1"
		[maximumQuestions]="progress.totalNumberOfQuestions"
		[currentQuestion]="currentQuestionNumber"
		[currentQuestionsPerPage]="defaultQuestionPerPage"
		[isItemChangeValid]="isItemChangeValid"
		(onItemChange)="updateItemsPerPage($event)"
		(validateRequest)="onValidateRequest($event)"
		(submitAudit)="onSubmit($event)"></kpa-pagination>
</kendo-dialog>
